<template>
  <div class="current-date d-flex flex-column">
    <div class="comment">по состоянию на</div>
    <div class="d-flex align-center">
      <div class="block date">
        <span class="icon icon-calendar"></span>
        <span>{{ getDay }}</span>
      </div>
      <div class="block time">
        <span class="icon icon-clock"></span>
        <span>{{ getTime }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurrentDate',
  mounted () {
    this.updateTime = setInterval(() => {
      this.currentDate = new Date()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.updateTime)
  },
  data () {
    return {
      updateTime: null,
      listOfMonth: [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октябра',
        'ноября',
        'декабря',
      ],
      currentDate: new Date()
    }
  },
  computed: {
    getDay () {
      return this.currentDate.getDate() + ' ' + this.listOfMonth[this.currentDate.getMonth()];
    },
    getTime () {
      return (this.currentDate.getHours() < 10 ? '0' : '') + this.currentDate.getHours()
          + ':'
          + (this.currentDate.getMinutes() < 10 ? '0' : '') + this.currentDate.getMinutes()
          + ':'
          + (this.currentDate.getSeconds() < 10 ? '0' : '') + this.currentDate.getSeconds()
    }
  }
}
</script>

<style lang="scss">
</style>
